
import React, {useState, useContext, useEffect} from 'react';
import { Col, Row, Form, Card, Table, ButtonGroup, FormGroup, Button } from 'react-bootstrap';
import { useSnackbar } from 'notistack';
import axios from 'axios';
//import { fetchAuthSession } from 'aws-amplify/auth';
import Preloader from '../../components/Preloader/Preloader';
import { ProductContext } from '../../ProductProvider';
import {Helmet} from 'react-helmet-async';
import { fetchAuthSession } from 'aws-amplify/auth';
import {useReactToPrint} from "react-to-print";

const config = require('../../config.json');

export default function ReturnBooks() {
  const { validateLogin, loggedUser, generateDate } = useContext(ProductContext);
  const [searchBook, setSearchBook] = useState({type:'AccessionNo', value:''});
  const [loaded, setLoaded] = useState(true);
  const { enqueueSnackbar } = useSnackbar();
  const [bookResult, setBookResult] = useState([]);
  const [bookSelect, setBookSelect]= useState([]);
  const [filterResult, setFilterResult] = useState([]);
  const [sorting, setSorting]=useState({field:"",order:"asc"});
  const refBook = React.useRef([]);
  const [viewOption,setViewOption] = useState("All");
  const componentRef = React.useRef(null);

  // Scroll to top state and handlers
const [showScrollTop, setShowScrollTop] = useState(false);
const handleScroll = () => {
  if (window.scrollY > 200) {
    setShowScrollTop(true);
  } else {
    setShowScrollTop(false);
  }
};

useEffect(() => {
  window.addEventListener('scroll', handleScroll);
  return () => window.removeEventListener('scroll', handleScroll);
}, []);

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

    useEffect(()=>{
      if(!loggedUser.isAuthenticated){
        validateLogin();
      }else{
          handleReset();
          handleBookFetch('NA','All');
      }
    },[loggedUser])

    const reactToPrintContent = React.useCallback(() => {
      return componentRef.current;
    }, [componentRef.current]);
  
    const reactToPrintTrigger = React.useCallback(() => {
      return <Button variant="outline-primary"  size="sm">Print</Button>;
    }, []);  

    const reactPrint=useReactToPrint({
      contentRef: componentRef,
      documentTitle: "AwesomeFileName",
      //onAfterPrint: handleAfterPrint,
      //onBeforePrint: handleBeforePrint,
    });

    const handleBookFetch=async(value, type)=>{
      //event.preventDefault();
      //console.log("search book : ", searchBook);
      try{
          setLoaded(false);
          //setDispMsg('');
          const { idToken } = (await fetchAuthSession()).tokens ?? {};
          const clientID="AKLibrary";
          const searchValue = value;
          const searchTopic = type;
          await axios.get(`${config.api.invokeUrl}/issue?fetchKey=${searchValue}&fetchOption=${searchTopic}&clientID=${clientID}`, {
          headers: {
            Authorization: idToken,
           'x-api-key':config.api.key
          }
        }).then(async(response) => {
         console.log("response : ", response.data);
         //setDispMsg(response.data.length+' - Books Found');
          const tresponse = response.data;
          const todayDateStr = await generateDate();
          const todayDate = new Date(todayDateStr);
          const test = tresponse.map((item) => {
            const bookedOnDate = new Date(item.bookedOn);
            // Calculate days as difference between bookedOn and today (positive if overdue)
            const diffTime = todayDate - bookedOnDate;
            const days = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            let fine = 0;
            if (typeof item.userID === 'string') {
              if (item.userID.includes('BTH')||item.userID.includes('OYT')||item.userID.includes('RTD')) {
                if (days > 30) fine = days - 30;
              } else if (item.userID.includes('MTH')) {
                if (days > 40) fine = days - 40;
              }
            }
            return {
              ...item,
              days: days,
              fine: fine
            };
          });
          //console.log("Test :", test);
          setBookResult(test);
          setFilterResult(test);
          enqueueSnackbar(response.data.length+' - Books Found',{variant:'success'}); 
          setLoaded(true);
      }).catch((error)=>{
        //console.log("error:", error);
        enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'}); 
      setLoaded(true);
    })
      }catch(error){
          //console.log("error:", error);
          enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
      }
  

  }

  const handleBookSelection = (event, item) => {
    if (event.target.checked) {
      // Add item if not already present
      console.log("item ", item);
      if (!bookSelect.some(b => b.Accession_No === item.Accession_No)) {
        setBookSelect([...bookSelect, item]);
      }
    } else {
      // Remove item
      setBookSelect(bookSelect.filter(b => b.Accession_No !== item.Accession_No));
    }
  };

const handleBookReturns=async(event)=>{
  event.preventDefault();
  try{
      if(!bookSelect){
        enqueueSnackbar("Select the Book!",{variant : 'info'});
      }else if(bookSelect.length<=0){
        enqueueSnackbar("Select the Book!",{variant : 'info'});
      }else {
          setLoaded(false);
          const { idToken } = (await fetchAuthSession()).tokens ?? {};
          var uniqueArray = removeDuplicates("userEmailID");
          //console.log("unique:", bookSelect);
          //setLoaded(true);
          const todayDate=await generateDate();
          const params={
            clientID:loggedUser.family_name,
            bookSelect:bookSelect,
            bookStatus:"Available",
            bookedTo:todayDate,
            updatedBy:loggedUser.name,
            updatedOn:todayDate,
            uniqueArray:uniqueArray
          }; 
          //console.log("Return Params :", params);
          await axios.patch(`${config.api.invokeUrl}/returns`,params, {  
            headers: {
              Authorization: idToken,
              'x-api-key':config.api.key
            }
          }).then(async(response) => {
            //console.log("Res : ", response);
            const { idToken } = (await fetchAuthSession()).tokens ?? {};
            await axios.post(`${config.api.invokeUrl}/notification/returns`,params, {  
              headers: {
                Authorization: idToken,
                'x-api-key':config.api.key
              }
            });
            enqueueSnackbar("Book successfully returned",{variant:'success'});
            //handleReset();
            handleBookFetch('NA','All');
            Unchecked();
            setLoaded(true)
        }).catch((error)=>{
          //console.log("Error : ", error);
        enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'});
        setLoaded(true);
        window.scrollTo(0,0);
      })
    }
  }catch(error){
      //console.log("Error1 : ", error);
      setLoaded(true);
      enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
  }
}

const removeDuplicates=(tprop)=> {
  var newArray = [];
  var lookupObject  = {};
  for(var i in bookSelect) {
      lookupObject[bookSelect[i][tprop]] = bookSelect[i];
  }
  for(i in lookupObject) {
      newArray.push(lookupObject[i]);
  }
  return newArray;
}

const handleViewOptionChange=async(type)=>{
  const todayDate=await generateDate();
  if(type==="Today"){
    const tempOrginalValue=bookResult;
    var sortedOptionArray = tempOrginalValue.filter((item) => new Date(item.bookedTo) === new Date(todayDate));
    await setFilterResult(sortedOptionArray);
  }else if(type==="Over Due"){
    const tempOrginalValue=bookResult;
    sortedOptionArray = tempOrginalValue.filter((item) =>  new Date(item.bookedTo) < new Date(todayDate));
    await setFilterResult(sortedOptionArray);
  }else if(type==="All"){
    await setFilterResult(bookResult);
  }
  setViewOption(type);
}

const handleReset=()=>{
  setSearchBook({type:'AccessionNo', value:''});
  setBookResult([]);
  setBookSelect([]);
}

const handleSortKey =async(event, value, order)=>{
  event.preventDefault();
  if(value==="AccessionNo" && order==="asc"){
    const tempOrginalValue=bookResult;
    //setBookResult([]);
    //const tempFilterValue=tempOrginalValue.sort((a,b)=>)
    var sortedOptionArray = tempOrginalValue.sort((a, b) => {return a.Accession_No - b.Accession_No;});
    await setBookResult(sortedOptionArray);
    setSorting({field:"AccessionNo",order:"asc"});
  }else if(value==="AccessionNo" && order==="desc"){
    const tempOrginalValue=bookResult;
    //setBookResult([]);
    //const tempFilterValue=tempOrginalValue.sort((a,b)=>)
    sortedOptionArray = tempOrginalValue.sort((a, b) => {return b.Accession_No - a.Accession_No});
    await setBookResult(sortedOptionArray);
    setSorting({field:"AccessionNo",order:"desc"});
  }else if(value==="BookTitle" && order==="asc"){
    const tempOrginalValue=bookResult;
    //const tempFilterValue=tempOrginalValue.sort((a,b)=>)
    sortedOptionArray = tempOrginalValue.sort((a, b) => {
      if (a.Book_Title < b.Book_Title) {
        return 1;
      }
      if (a.Book_Title > b.Book_Title) {
        return -1;
      }
      return 0;
    });
    setSorting({field:"BookTitle",order:"asc"});
    await setBookResult(sortedOptionArray);
  }else if(value==="BookTitle" && order==="desc"){
    const tempOrginalValue=bookResult;
    //const tempFilterValue=tempOrginalValue.sort((a,b)=>)
      sortedOptionArray = tempOrginalValue.sort((a, b) => {
        if (a.Book_Title < b.Book_Title) {
          return -1;
        }
        if (a.Book_Title > b.Book_Title) {
          return 1;
        }
        return 0;
      }); 
    setSorting({field:"BookTitle",order:"desc"});
    await setBookResult(sortedOptionArray);
  }else if(value==="BookAuthor" && order==="asc"){
    const tempOrginalValue=bookResult;
    //const tempFilterValue=tempOrginalValue.sort((a,b)=>)
    sortedOptionArray = tempOrginalValue.sort((a, b) => {
      if (a.Book_Author < b.Book_Author) {
        return 1;
      }
      if (a.Book_Author > b.Book_Author) {
        return -1;
      }
      return 0;
    });
    setSorting({field:"BookAuthor",order:"asc"});
    await setBookResult(sortedOptionArray);
  }else if(value==="BookAuthor" && order==="desc"){
    const tempOrginalValue=bookResult;
    //const tempFilterValue=tempOrginalValue.sort((a,b)=>)
    sortedOptionArray = tempOrginalValue.sort((a, b) => {
        if (a.Book_Author < b.Book_Author) {
          return -1;
        }
        if (a.Book_Author > b.Book_Author) {
          return 1;
        }
        return 0;
      }); 
    setSorting({field:"BookAuthor",order:"desc"});
    await setBookResult(sortedOptionArray);
  }else if(value==="IssuedTo" && order==="asc"){
    const tempOrginalValue=bookResult;
    //const tempFilterValue=tempOrginalValue.sort((a,b)=>)
    sortedOptionArray = tempOrginalValue.sort((a, b) => {
      if (a.bookedfor < b.bookedfor) {
        return 1;
      }
      if (a.bookedfor > b.bookedfor) {
        return -1;
      }
      return 0;
    });
    setSorting({field:"IssuedTo",order:"asc"});
    await setBookResult(sortedOptionArray);
  }else if(value==="IssuedTo" && order==="desc"){
    const tempOrginalValue=bookResult;
    //const tempFilterValue=tempOrginalValue.sort((a,b)=>)
      sortedOptionArray = tempOrginalValue.sort((a, b) => {
        if (a.bookedfor < b.bookedfor) {
          return -1;
        }
        if (a.bookedfor > b.bookedfor) {
          return 1;
        }
        return 0;
      }); 
    setSorting({field:"IssuedTo",order:"desc"});
    await setBookResult(sortedOptionArray);
  }
}

const handleBookFilter = async(event)=>{
  event.preventDefault();
  //console.log("book result ", bookResult);
  await setSearchBook({...searchBook, 
    value:(event.target.value).toUpperCase()
  });
  const tempOrginalValue=bookResult;
  const searchValue = (event.target.value).toUpperCase();
  const searchTopic = searchBook.type;
  //console.log("search value :", searchValue);
  //console.log("search topic :", searchTopic);
  //console.log("bookResult :", tempOrginalValue);
  var tempFilter=[]
  if(searchTopic==="AccessionNo"){
    tempFilter = tempOrginalValue.filter((item)=>item.Accession_No.includes(searchValue));
  }else if(searchTopic==="BookTitle"){
    tempFilter = tempOrginalValue.filter((item)=>item.Book_Title.includes(searchValue));
  }else if(searchTopic==="UserName"){
    tempFilter = tempOrginalValue.filter((item)=>item.bookedfor.includes(searchValue));
  }else if(searchTopic==="Author"){
    tempFilter = tempOrginalValue.filter((item)=>item.Book_Author.includes(searchValue));
  }else if(searchTopic==="IssueID"){
    tempFilter = tempOrginalValue.filter((item)=>item.issueID.includes(searchValue));
  }else if(searchTopic==="UserID"){
    tempFilter = tempOrginalValue.filter((item)=>item.userID.includes(searchValue));
  }
  if(searchValue===""){
    tempFilter = tempOrginalValue;
  }
  //console.log("filtered value ", tempFilter);
  setFilterResult(tempFilter);
}

const handleSearchTypeChange=(event)=>{
  event.preventDefault();
  setSearchBook({...searchBook, type:event.target.value});
  const tempOrginalValue=bookResult;
  const searchValue = searchBook.value.toUpperCase();
  const searchTopic = event.target.value;
  //console.log("search value :", searchValue);
  //console.log("search topic :", searchTopic);
  //console.log("bookResult :", tempOrginalValue);
  var tempFilter=[]
  if(searchTopic==="AccessionNo"){
    tempFilter = tempOrginalValue.filter((item)=>item.Accession_No.includes(searchValue));
  }else if(searchTopic==="BookTitle"){
    tempFilter = tempOrginalValue.filter((item)=>item.Book_Title.includes(searchValue));
  }else if(searchTopic==="UserName"){
    tempFilter = tempOrginalValue.filter((item)=>item.bookedfor.includes(searchValue));
  }else if(searchTopic==="Author"){
    tempFilter = tempOrginalValue.filter((item)=>item.Book_Author.includes(searchValue));
  }else if(searchTopic==="IssueID"){
    tempFilter = tempOrginalValue.filter((item)=>item.issueID.includes(searchValue));
  }else if(searchTopic==="UserID"){
    tempFilter = tempOrginalValue.filter((item)=>item.userID.includes(searchValue));
  }
  if(searchValue===""){
    tempFilter = tempOrginalValue;
  }
  //console.log("filtered value ", tempFilter);
  setFilterResult(tempFilter);

}

const Unchecked = () => {
  //console.log(refBook.current.length)
  for (let i = 0; i < refBook.current.length; i++) {
    if(refBook.current[i]!==null){
      refBook.current[i].checked = false;
    }
    //  ref.current[i].checked = false;
  }
}
 
  // Modern button style for ReturnBooks page
  const returnBooksModernStyles = `
    .btn-box {
      background: linear-gradient(90deg, #4f8cff 0%, #6ed0fa 100%) !important;
      color: #fff !important;
      border: none !important;
      border-radius: 10px !important;
      font-weight: 600;
      box-shadow: 0 2px 8px 0 rgba(44, 62, 80, 0.07);
      transition: background 0.2s, box-shadow 0.2s, transform 0.2s;
    }
    .btn-box:hover, .btn-box:focus {
      background: linear-gradient(90deg, #063547 60%, #7ee8fa 100%) !important;
      color: #fff !important;
      transform: translateY(-2px) scale(1.03);
      box-shadow: 0 4px 16px 0 rgba(44, 62, 80, 0.13);
    }
  `;
  
  return (
    <div className='container' style={{padding:"10px"}}>
    <style>{returnBooksModernStyles}</style>
    <Helmet>
      <title>Return Books - Inigo Library - Arul Kadal - Chennai</title>
      <meta name="description" content="Return Books - Inigo Library - Arul Kadal - Chennai" />
      <meta name="keywords" content="Return Books - Inigo Library - Arul Kadal - Chennai" /> 
    </Helmet>
   {/* <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
        <p>Test</p>
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><i className="fa fa-home" aria-hidden="true"></i></Breadcrumb.Item>
            <Breadcrumb.Item>subscriber</Breadcrumb.Item>
            <Breadcrumb.Item active>Registration Form</Breadcrumb.Item>
          </Breadcrumb>
        </div>*/}
       {/*} </div>*/}
     
    <div className="section" style={{padding: 0, margin: 0}}>
      {!loaded && <Preloader show={loaded ? false : true} />}
      {/*Book Details
      <h4 style={{textAlign:"center", margin: '10px 0 8px 0', fontWeight: 600, fontSize: '1.15rem', letterSpacing: 0.2}}>Return Book's</h4>
      */}
      <Card style={{padding: '0', boxShadow:'0 2px 12px rgba(6,53,71,0.08)', borderRadius: '14px', border: 'none', background: '#fafdff', marginBottom: 0}}>
        <Card.Body style={{borderRadius: '14px', padding: '14px 10px 10px 10px'}}>
      {/*<div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-2">
      <div className="d-block mb-4 mb-md-0">
      </div>
      <div className="btn-toolbar mb-2 mb-md-0 cursor-pointer"> 
      <ButtonGroup>
      <i className="fa fa-print " aria-hidden="true" onClick={reactPrint}></i>
      </ButtonGroup>
          </div>
         </div>*/}


      <div className="position-relative d-flex flex-wrap align-items-center flex-md-nowrap" style={{background: 'linear-gradient(90deg, #e3f6fc 0%, #fafdff 100%)', borderRadius: '8px', marginBottom: 8, boxShadow: '0 1px 4px rgba(6,53,71,0.04)', fontSize: '12px', padding: '4px 8px 4px 8px', minHeight: '36px'}}>
        <h4 style={{
          position: 'absolute',
          left: 0,
          right: 0,
          margin: '0 auto',
          textAlign: 'center',
          fontWeight: 600,
          fontSize: '1.15rem',
          letterSpacing: 0.2,
          zIndex: 1,
          width: 'fit-content',
          top: '50%',
          transform: 'translateY(-50%)',
          background: 'transparent',
          padding: '0 16px'
        }}>Return Book's</h4>
        <div className="btn-toolbar d-flex flex-column flex-md-row align-items-stretch align-items-md-center justify-content-end w-100 w-md-auto ms-auto" style={{gap: '0.5rem', fontSize: '12px', margin: 0, zIndex: 2}}>
          <div className="d-flex flex-row flex-md-row align-items-center justify-content-center mb-2 mb-md-0" style={{background: '#fff', borderRadius: '6px', boxShadow: '0 1px 4px rgba(6,53,71,0.04)', fontSize: '12px', padding: '2px 8px', minWidth: 0}}>
            <label className="d-flex align-items-center me-3 mb-0" style={{cursor:'pointer', gap:'4px'}}>
              <input
                type="radio"
                name="radioView"
                value="All"
                checked={viewOption==="All"}
                onChange={() => { handleViewOptionChange("All") }}
                style={{marginRight: '4px'}}
              />
              <span style={{fontWeight:500, color:'#063547', fontSize:'12px'}}>All</span>
            </label>
            <label className="d-flex align-items-center me-3 mb-0" style={{cursor:'pointer', gap:'4px'}}>
              <input
                type="radio"
                name="radioView"
                value="Today"
                checked={viewOption==="Today"}
                onChange={() => { handleViewOptionChange("Today") }}
                style={{marginRight: '4px'}}
              />
              <span style={{fontWeight:500, color:'#063547', fontSize:'12px'}}>Today</span>
            </label>
            <label className="d-flex align-items-center mb-0" style={{cursor:'pointer', gap:'4px'}}>
              <input
                type="radio"
                name="radioView"
                value="Over Due"
                checked={viewOption==="Over Due"}
                onChange={() => { handleViewOptionChange("Over Due") }}
                style={{marginRight: '4px'}}
              />
              <span style={{fontWeight:500, color:'#d7263d', fontSize:'12px'}}>Over Due</span>
            </label>
          </div>
          <ButtonGroup style={{background: '#fff', borderRadius: '8px', boxShadow: '0 1px 4px rgba(6,53,71,0.06)'}}>
            <i className="fa fa-print" aria-hidden="true" onClick={reactPrint} style={{fontSize: '20px', color: '#063547', cursor: 'pointer', padding: '6px 14px'}} title="Print"></i>
          </ButtonGroup>
        </div>
      </div>

        <div style={{position: 'sticky', top: 0, zIndex: 10, background: '#fafdff', borderRadius: '14px 14px 0 0', boxShadow: '0 2px 8px rgba(6,53,71,0.04)'}}>
          <Form style={{marginBottom: 0}}>
            <Row className="align-items-end g-2" style={{marginBottom: 0}}>
            <Col xs={12} sm={6} md={2} className="mb-2" style={{paddingRight: 6, minWidth: 120}}>
              <Form.Group id="firstName" style={{marginBottom: 0}}>
                <Form.Label style={{fontSize: '12px', marginBottom: 2}}>Search Type</Form.Label>
                <Form.Select size="sm" style={{fontSize:12, borderRadius:7, padding:4, width:"100%"}}
                  value={searchBook.type}
                  onChange={event=>{handleSearchTypeChange(event)}}
                >
                  <option value="UserName">User Name</option>
                  <option value="AccessionNo">Accession No</option>
                  <option value="UserID">User ID</option>
                  <option value="BookTitle">Book Title</option>
                  <option value="Author">Author</option>
                  <option value="IssueID">Issue ID</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6} md={6} className="mb-2" style={{paddingRight: 6, minWidth: 180}}>
              <Form.Group id="middleName" style={{marginBottom: 0}}>
                <Form.Label style={{fontSize: '12px', marginBottom: 2}}>Search Details</Form.Label>
                <Form.Control required type="text" placeholder="Enter details to filter...."
                  value={searchBook.value}
                  onChange={event=>{handleBookFilter(event)}}
                  size="sm"
                  style={{fontSize:12, borderRadius:7, padding:4}}
                />
              </Form.Group>
            </Col>
            <Col xs={6} sm={6} md={2} className="mb-2" style={{paddingRight: 6, minWidth: 90}}>
              <button className='btn-box w-100' style={{marginTop:"0", padding: '4px 12px', fontSize: '12px', borderRadius: 7}} onClick={event=>handleBookReturns(event)}>Return</button>
            </Col>
            <Col xs={6} sm={6} md={2} className="mb-2" style={{minWidth: 90}}>
              <button className='btn-box w-100' style={{marginTop:"0", padding: '4px 12px', fontSize: '12px', borderRadius: 7}} onClick={event=>handleBookFetch('NA','All')}>Refresh</button>
            </Col>
            </Row>
          </Form>
        </div>
        {filterResult.length>0 ? <div ref={componentRef} style={{width: '100%', overflowX: 'auto', maxHeight: '60vh', minHeight: '200px', marginTop: 8, borderRadius: '0 0 14px 14px', boxShadow: '0 2px 8px rgba(6,53,71,0.04)', background: '#fff'}}>
          <h6 style={{fontSize: '1rem', margin: '8px 0 8px 0', position: 'sticky', top: 0, background: '#fff', zIndex: 2, borderRadius: '0 0 8px 8px'}}>Issued Book's due for Return - {filterResult.length}</h6>
          <div style={{minWidth: 600, width: '100%', overflowX: 'auto'}}>
            <Table striped bordered hover responsive style={{minWidth:'600px', background:'#fff', borderRadius:'12px', overflow:'auto', boxShadow:'none', marginBottom: 0}}>
              <thead style={{position:'sticky', top:0, background:'linear-gradient(90deg, #e3f6fc 0%, #fafdff 100%)', zIndex:2, fontSize:'13px', color:'#063547', fontWeight:600, letterSpacing:0.5, borderBottom:'2px solid #e3f6fc'}}>
                <tr className='text-center'>
                  <th style={{width:'36px', fontSize:'13px', background:'transparent'}}>
                    <input type="checkbox" style={{width:'16px', height:'16px'}}
                      onChange={e => {
                        if (e.target.checked) {
                          setBookSelect([...filterResult]);
                          refBook.current.forEach(cb => { if(cb) cb.checked = true; });
                        } else {
                          setBookSelect([]);
                          refBook.current.forEach(cb => { if(cb) cb.checked = false; });
                        }
                      }}
                      title="Select/Deselect All"
                    />
                  </th>
                  <th style={{fontSize:'13px', background:'transparent'}}>Accession No  {sorting.field==="AccessionNo" && sorting.order==="asc" ? <i className="fa fa-arrow-down text-primary" aria-hidden="true" onClick={event=>handleSortKey(event, "AccessionNo","desc")} style={{cursor:'pointer'}}></i>:<i className="fa fa-arrow-up text-primary" aria-hidden="true" onClick={event=>handleSortKey(event, "AccessionNo", "asc")} style={{cursor:'pointer'}}></i>}</th>
                  <th style={{fontSize:'13px', background:'transparent'}}>Book Title {sorting.field==="BookTitle" && sorting.order==="asc" ? <i className="fa fa-arrow-down text-primary" aria-hidden="true" onClick={event=>handleSortKey(event, "BookTitle","desc")} style={{cursor:'pointer'}}></i>:<i className="fa fa-arrow-up text-primary" aria-hidden="true" onClick={event=>handleSortKey(event, "BookTitle", "asc")} style={{cursor:'pointer'}}></i>}</th>
                  <th style={{fontSize:'13px', background:'transparent'}}>Author  {sorting.field==="BookAuthor" && sorting.order==="asc" ? <i className="fa fa-arrow-down text-primary" aria-hidden="true" onClick={event=>handleSortKey(event, "BookAuthor","desc")} style={{cursor:'pointer'}}></i>:<i className="fa fa-arrow-up text-primary" aria-hidden="true" onClick={event=>handleSortKey(event, "BookAuthor", "asc")} style={{cursor:'pointer'}}></i>}</th>
                  <th style={{fontSize:'13px', background:'transparent'}}>Call No</th>
                  <th style={{fontSize:'13px', background:'transparent'}}>Issued To {sorting.field==="IssuedTo" && sorting.order==="asc" ? <i className="fa fa-arrow-down text-primary" aria-hidden="true" onClick={event=>handleSortKey(event, "IssuedTo","desc")} style={{cursor:'pointer'}}></i>:<i className="fa fa-arrow-up text-primary" aria-hidden="true" onClick={event=>handleSortKey(event, "IssuedTo", "asc")} style={{cursor:'pointer'}}></i>}</th>
                  <th style={{fontSize:'13px', background:'transparent'}}>Booking Date</th>
                  <th style={{fontSize:'13px', background:'transparent'}}>Due Date</th>
                  <th style={{fontSize:'13px', background:'transparent'}} title="Days since issued">Days <i className="fa fa-info-circle text-secondary" title="Days since the book was issued"></i></th>
                  <th style={{fontSize:'13px', background:'transparent'}} title="Fine for overdue">Fine <i className="fa fa-info-circle text-secondary" title="Fine for overdue books"></i></th>
                </tr>
              </thead>
              <tbody>
                {filterResult.map((item,index)=>{
                  const isOverdue = item.fine > 0;
                  return (
                    <tr key={index} className={isOverdue ? 'table-danger' : ''} style={{fontWeight: isOverdue ? '600' : '400', fontSize:'13px', transition:'background 0.2s', cursor:'pointer', borderBottom:'1px solid #f1f3f4'} }
                      onMouseOver={e => e.currentTarget.style.background = isOverdue ? '#ffeaea' : '#f6fcff'}
                      onMouseOut={e => e.currentTarget.style.background = isOverdue ? '#f8d7da' : '#fff'}
                    >
                      <td className='text-center' style={{fontSize:'13px'}}>
                        <input
                          type="checkbox"
                          ref={el => refBook.current[index] = el}
                          onChange={e => handleBookSelection(e, item)}
                          style={{width:'16px', height:'16px'}}
                          checked={bookSelect.some(b => b.Accession_No === item.Accession_No)}
                          title={`Select book ${item.Accession_No}`}
                        />
                      </td>
                      <td style={{fontSize:'13px'}}>{item.Accession_No  }</td>
                      <td style={{maxWidth:180, whiteSpace:'pre-line', wordBreak:'break-word', fontSize:'13px'}}>{item.Book_Title}</td>
                      <td style={{maxWidth:140, whiteSpace:'pre-line', wordBreak:'break-word', fontSize:'13px'}}>{item.Book_Author}</td>
                      <td style={{fontSize:'13px'}}>{item.Book_Classification_No}{" "}{item.authorMark}</td>
                      <td style={{fontSize:'13px'}}>{item.bookedfor} <p style={{fontSize:'12px', margin:0, color:'#888'}}>({item.userID})</p></td>
                      <td style={{fontSize:'13px'}}>{item.bookedOn}</td>
                      <td style={{fontSize:'13px'}}>{item.bookedTo}</td>
                      <td title="Days since issued" className='text-center' style={{fontSize:'13px'}}>{item.days}</td>
                      <td className='text-center' style={{fontSize:'13px'}}>
                        {item.fine > 0 ? (
                          <span className="badge bg-danger" style={{fontSize:'12px', padding:'6px 10px', borderRadius:'8px', letterSpacing:0.5}} title={`Overdue by ₹${item.fine}`}>₹{item.fine}</span>
                        ) : (
                          <span className="text-success" style={{fontWeight:500}} title="No fine">-</span>
                        )}
                      </td>
                    </tr>
                  )})}
              </tbody>
              {/* Total Fine Row */}
              <tfoot>
                <tr style={{background:'#e3f6fc', fontWeight:700, fontSize:'14px'}}>
                  <td colSpan={9} className='text-end'>Total Fine</td>
                  <td className='text-center text-danger'>₹{filterResult.reduce((sum, item) => sum + (item.fine || 0), 0)}</td>
                </tr>
              </tfoot>
            </Table>
          </div>
        </div> : null}
          </Card.Body>
        </Card>
        <div className="mt-3 text-center">
          <button className='btn-box' onClick={event=>handleBookReturns(event)}>Return Books</button>
        </div>

    {/* Scroll To Top Icon */}
    {showScrollTop && (
      <button
        onClick={scrollToTop}
        style={{
          position: 'fixed',
          bottom: '40px',
          right: '40px',
          zIndex: 9999,
          background: 'linear-gradient(135deg, #063547 60%, #7ee8fa 100%)',
          color: '#fff',
          border: 'none',
          borderRadius: '50%',
          width: '48px',
          height: '48px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '24px',
          transition: 'background 0.3s',
        }}
        aria-label="Scroll to top"
        title="Scroll to top"
      >
        <i className="fa fa-arrow-up" aria-hidden="true"></i>
      </button>
    )}
    </div>
    </div>
  )
}
